var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRateIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Property 1=events"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.4999 17.4897L16.8228 20.1042C17.6145 20.5834 18.5833 19.8751 18.3749 18.9792L17.2291 14.0626L21.052 10.7501C21.7499 10.1459 21.3749 9.00008 20.4583 8.92717L15.427 8.50008L13.4583 3.85425C13.1041 3.0105 11.8958 3.0105 11.5416 3.85425L9.57284 8.48967L4.54159 8.91675C3.62492 8.98966 3.24992 10.1355 3.94784 10.7397L7.77076 14.0522L6.62492 18.9688C6.41659 19.8647 7.38534 20.573 8.17701 20.0938L12.4999 17.4897Z",
    fill: "currentColor"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRateIcon);
export default __webpack_public_path__ + "static/media/rateIcon.9616f120079e7c4b7c3686ae47927e4c.svg";
export { ForwardRef as ReactComponent };